import { render, staticRenderFns } from "./EventModalClient.vue?vue&type=template&id=597b545c&scoped=true"
import script from "./EventModalClient.vue?vue&type=script&lang=js"
export * from "./EventModalClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b545c",
  null
  
)

export default component.exports